import axios from 'axios';
import { getToken } from './auth';

const API_URL = process.env.REACT_APP_API_URL || 'https://backend.chamafruits.com';

const withAuth = () => ({
  headers: { Authorization: `Bearer ${getToken()}` },
  withCredentials: true,
});

export const getRegisterlessPosProfile = async (branchId) =>
  (await axios.get(`${API_URL}/branch/${branchId}/registerless-pos-profile`, withAuth())).data;

export const getMyRegisterlessPosProfile = async (branchId) =>
  (await axios.get(`${API_URL}/branch/${branchId}/registerless-pos-profile/me`, withAuth())).data;

export const updateRegisterlessPosProfile = async (branchId, payload) =>
  (await axios.put(`${API_URL}/branch/${branchId}/registerless-pos-profile`, payload, withAuth())).data;

export const requestRegisterlessDiscountAuthorization = async (branchId, payload) => {
  try {
    const response = await axios.post(
      `${API_URL}/branch/${branchId}/registerless-pos-profile/discounts/request`,
      payload,
      withAuth()
    );
    return response.data;
  } catch (error) {
    const err = new Error(error.response?.data?.message || 'Error solicitando autorizacion de descuento');
    err.attemptsRemaining = error.response?.data?.attemptsRemaining;
    throw err;
  }
};

export const validateRegisterlessDiscountAuthorization = async (branchId, payload) => {
  try {
    const response = await axios.post(
      `${API_URL}/branch/${branchId}/registerless-pos-profile/discounts/validate`,
      payload,
      withAuth()
    );
    return response.data;
  } catch (error) {
    const err = new Error(error.response?.data?.message || 'Error validando autorizacion de descuento');
    err.attemptsRemaining = error.response?.data?.attemptsRemaining;
    throw err;
  }
};
